import { Accordion } from "@made-people/blueprint-accordion";
import type { FaqItem } from "./parse-faq-items";

export const FaqQnaItems = ({
  items,
  onQuestionOpen,
}: {
  items: FaqItem[];
  onQuestionOpen?: (question: string) => void;
}) => {
  return (
    <Accordion
      layout={{ spacing: { applySpacing: "false" } }}
      items={items.map((item) => ({
        content: {
          value: item.question,
          trigger: (
            <span className="max-lg:text-heading-sm max-lg:font-medium">
              {item.question}
            </span>
          ),
          content: item.answer,
        },
        radixAccordionItemSettings: {
          item: {
            className:
              "group overflow-hidden border-t border-gray-200 last:border-b py-2 lg:py-4",
          },
          trigger: {
            onClick: (event) => {
              if (event.currentTarget.dataset.state === "closed") {
                onQuestionOpen?.(item.question);
              }
            },
          },
        },
      }))}
    />
  );
};
